import { render, staticRenderFns } from "./NewsTitle.vue?vue&type=template&id=5631325a&scoped=true&"
import script from "./NewsTitle.vue?vue&type=script&lang=js&"
export * from "./NewsTitle.vue?vue&type=script&lang=js&"
import style0 from "./NewsTitle.vue?vue&type=style&index=0&id=5631325a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631325a",
  null
  
)

export default component.exports